import React, { createContext, useContext, useMemo, useState } from 'react';

// /////////////////////////////////////////////////////////////////////////////

interface LogCardContextValue {
  isExpertMode: boolean;
  setIsExpertMode: (value: boolean) => void;
}

const LogCardContext = createContext<LogCardContextValue | null>(null);

export const useLogCardContext = (): LogCardContextValue => {
  const context = useContext(LogCardContext);

  if (!context) {
    throw new Error(
      'useLogCardContext must be used within LogCardContext.Provider',
    );
  }

  return context;
};

interface LogCardProviderProps {
  children: React.ReactNode;
}

export const LogCardProvider = ({
  children,
}: LogCardProviderProps): React.JSX.Element => {
  const [isExpertMode, setIsExpertMode] = useState(false);

  const value = useMemo(
    () => ({ isExpertMode, setIsExpertMode }),
    [isExpertMode],
  );

  return (
    <LogCardContext.Provider value={value}>{children}</LogCardContext.Provider>
  );
};
